import TwoFactorAuthHandler from "components/jiffy/masthead-redesign2025/local-delivery/address-editor/two-factor-auth-handler";
import TwoFactorModalManager from "components/jiffy/masthead-redesign2025/local-delivery/address-editor/two-factor-modal-manager";

/**
 * Shows two-factor authentication modal
 *
 * Shared helper to initialize and display 2FA modal for address operations.
 * Coordinates TwoFactorAuthHandler and TwoFactorModalManager setup.
 *
 * @param {Object} options - Configuration options
 * @param {Function} options.saveAddress - Function to save address with auth token: (authToken) => Promise<result>
 * @param {Function} options.setLoading - Function to set loading state: (isLoading) => void
 * @param {HTMLElement|null} options.errorMessageElement - Element to display error messages (optional)
 * @param {number|null} [options.addressId=null] - Address ID for updates (optional)
 * @param {HTMLElement} options.targetContainer - Container element for modal
 */
// eslint-disable-next-line import/prefer-default-export
export function showTwoFactorModal({
  saveAddress,
  setLoading,
  errorMessageElement,
  addressId = null,
  targetContainer
}) {
  const authHandler = new TwoFactorAuthHandler({
    saveAddress,
    setLoading,
    errorMessageElement
  });

  const modalManager = new TwoFactorModalManager({
    addressId,
    authHandler,
    errorMessageElement,
    setLoading,
    targetContainer
  });

  modalManager.show();
}
